import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  errors: FieldErrors<SubscribeFormValues>;
  required?: boolean;
  hidden?: boolean;
}

export default function LastNameField({ register, errors, required, hidden }: Props) {
  if (hidden) return null;
  return (
    <div className="form-row form-row--inline js-form-item-lastname">
      <label className="form-label">Nazwisko{required ? '*' : ''}</label>
      <input className="form-input" {...register('lastName')} />
      {errors.lastName && <div className="form-error">{errors.lastName.message}</div>}
    </div>
  );
}
